import React from "react";
import ReactDOM from "react-dom/client";
import "../weather.css";

// The original prototype components expose their public API on `window`.
// Loading them in dependency order lets us ship the proven UI through Vite
// without rewriting the app and risking behavior regressions.
window.React = React;
window.ReactDOM = ReactDOM;

await import("../weather-data.js");
await import("../tweaks-panel.jsx");
await import("../weather-icons.jsx");
await import("../weather-bg.jsx");
await import("../weather-components.jsx");
await import("../weather-screens.jsx");
await import("../weather-search.jsx");
await import("../weather-radar.jsx");
await import("../weather-app.jsx");
